import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useAnalytics } from '../hooks/useAnalytics';

const NotFoundPage: React.FC = () => {
  const { trackEvent } = useAnalytics();
  const location = useLocation();

  useEffect(() => {
    trackEvent('Error', '404 Not Found', location.pathname);
  }, [location.pathname, trackEvent]);

  return (
    <div className="container-custom py-24 min-h-[70vh] flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-primary-600 mb-4">404</h1>
        <h2 className="text-3xl md:text-4xl font-semibold mb-4">Страница не найдена</h2>
        <p className="text-xl text-gray-600 mb-8 max-w-md mx-auto">
          Извините, запрашиваемая страница не существует или была перемещена.
        </p>
        <Link to="/" className="btn-primary inline-flex items-center">
          <ArrowLeft className="mr-2 w-5 h-5" />
          Вернуться на главную
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
